(function(angular){
	'use strict';

	angular
		.module('authModule')
		.controller('additionalResetQuestionsController', [
			'$timeout',
			'globalConfig',
			'urlFactory',
			AdditionalResetQuestionsController
		]);

	function AdditionalResetQuestionsController(
		$timeout,
		globalConfig,
		urlFactory
	){
		var additionalResetQuestions = this;

		additionalResetQuestions.$onInit = function() {
			angular.extend(additionalResetQuestions, globalConfig);
			
			if(angular.isDefined(additionalResetQuestions.serverSideErrorMap)) {
				$timeout(function() {
					urlFactory.handleServerValidation(
						additionalResetQuestions.additionalResetQuestionsForm,
						urlFactory.spoofApiError(additionalResetQuestions.serverSideErrorMap)
					);
				}, 100);
			}
		};
	}
})(window.angular);